import { render, staticRenderFns } from "./ReminderBlockList.vue?vue&type=template&id=2ef8dbda&"
import script from "./ReminderBlockList.vue?vue&type=script&lang=js&"
export * from "./ReminderBlockList.vue?vue&type=script&lang=js&"
import style0 from "./ReminderBlockList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports